import React from "react";
import styled, { css, keyframes } from "styled-components";
import { ColorTokens, useColorTokens } from "@tvg/design-system";

const pulseAnimation = (colorTokens: ColorTokens) => keyframes`
  0% {
    fill: ${colorTokens.content.loadingDefault};
  }
  
  50% {
    fill: ${colorTokens.border.default};
  }
  
  100% {
    fill: ${colorTokens.content.loadingDefault};
  }
`;

const SVG = styled.svg`
  display: block;
  width: 100%;
  height: 30px;

  rect.pulse {
    animation: ${() => {
      const colorTokens = useColorTokens();
      return css`
        ${pulseAnimation(colorTokens)} 1.25s infinite
      `;
    }};
  }
`;

export const IppStatsMask = () => {
  const colorTokens = useColorTokens();
  return (
    <div data-qa-label="ippStatsMask">
      <SVG>
        <rect
          className="pulse"
          width="55"
          height="9"
          x="12"
          y="9"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
        <rect
          className="pulse"
          width="60"
          height="9"
          x="75"
          y="9"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
        <rect
          className="pulse"
          width="63"
          height="9"
          x="143"
          y="9"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
      </SVG>
    </div>
  );
};
